import { createFileRoute } from '@tanstack/react-router';
import { PERMISSION_COST } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import OperatingCostsOverView from '../../components/OperationCosts/OperatingCostsOverView';

export const Route = createFileRoute('/_authenticated/costs/')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_COST, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'menu.costsOverview',
        suffix: 'menu.costs',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: CostsRoute,
});

function CostsRoute() {
  return <OperatingCostsOverView />;
}
